import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { vaultPasswordsService, basicService } from '@app/services';
import { PageLoader, PasslyButton } from '@app/components';

interface IReceivedData {
    file: any;
    secretKey: string;
    initialGroup: string;
    initialPolicy: string;
}

const DoMigrationComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [savedSuccessfully, setSavedSuccessfully] = useState<boolean>(false);

    useEffect(() => {
        if (props.file.length === 0 || props.secretKey === '' || props.initialPolicy === '') {
            setErrorMessage(translation('ON_PREM_MIGRATOR_MIGRATE_ERROR'));
        }
        else {
            // try to send data to server
            let formData = new FormData();
            formData.append('file', props.file[0]);

            vaultPasswordsService.onPremMigration(formData, props.secretKey, props.initialGroup, props.initialPolicy, handleError, handleSuccess);
        }
    }, []);

    const handleSuccess = (response: any) => {
        setSavedSuccessfully(true);
    };

    const handleError = (errorResponse: any) => {
        if (errorResponse.data.error) {
            setErrorMessage(errorResponse.data.error.message);
        }
        else if (errorResponse.message) {
            setErrorMessage(errorResponse.message);
        }
        else {
            setErrorMessage(translation('GENERIC_ERROR'));
        }
    };

    return (
        <>
            {errorMessage ?
                <div className='modal__error'>{errorMessage}</div>
                :
                <>
                    {savedSuccessfully ?
                        <div className='migrateOnPrem__has-perm-details-uploader'>
                            <div>{translation('ON_PREM_MIGRATOR_MIGRATE_CONFIRM')}</div>
                            <PasslyButton color='primary' variant='contained' onClick={() => { basicService.redirect('/passwordserver/vaults'); }}>
                                {translation('GO_TO_VAULTS')}
                            </PasslyButton>
                        </div>
                        :
                        <PageLoader />
                    }
                </>
            }
        </>
    );
};

export default DoMigrationComponent;